import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';


@Component({
    selector: 'app-dealer',
    templateUrl: './dealer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerComponent {

  currentUserId$: Observable<string>;
  currentUserId: string = "";

  constructor(

    private store: Store, 
    private router: Router) { 

      this.currentUserId$ = store.select(selectLoggedInUserDataId);
    }

    ngOnInit(): void {
    
      this.currentUserId$.subscribe(
        (userId: string) => {
          this.currentUserId = userId;
        }
      );
    } 

    goToSellerPublicPage(): any{

      this.router.navigate(
        ['/account/seller-public'],
        { queryParams: { id: this.currentUserId } }
      );
    }

}
